import { Reveal } from "@/components/Reveal";
import ProductCard from "@/components/ProductCard";
import { useProducts } from "@/context/ProductsContext";

export default function ComboCarousel() {
  const { products } = useProducts();
  const combos = products.filter((p) => p.priceCombo != null && p.available !== false);
  if (combos.length === 0) return null;

  return (
    <section data-testid="combo-section" className="bg-[#EFE9E1]">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <Reveal className="flex items-end justify-between mb-12">
          <div>
            <p className="overline-label">Online exclusive</p>
            <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4">Duo Sets</h2>
            <p className="mt-4 max-w-md text-sm md:text-base text-black/55 leading-relaxed">50 ml Parfum paired with its 10 ml Roll-On — for the vanity and for the road.</p>
          </div>
        </Reveal>
        <div className="flex gap-6 overflow-x-auto snap-x snap-mandatory no-scrollbar -mx-5 px-5 scroll-pl-5 md:mx-0 md:px-0 md:scroll-pl-0 pb-4" data-testid="combo-track">
          {combos.map((p) => (
            <div key={p.slug} className="snap-start shrink-0 w-[78vw] sm:w-[44vw] md:w-[31%] lg:w-[23.5%]">
              <ProductCard p={p} defaultVariant="combo" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
